<script setup lang="ts">
const { provider, redirectTo } = defineProps<{
  provider: Idsp
  redirectTo?: string
}>()

const auth = useAuthorizeStore()

const { public: env } = useRuntimeConfig()

const redirectCookie = useRedirectCookie()

const route = useRoute()

function login(idsp: Idsp) {
  const redir = toValue(redirectTo) ?? route.path
  if (redir) {
    redirectCookie.value = redir
  }

  auth.logout(true)

  return navigateTo(
    getAuthUrl(idsp, env),
    { external: true },
  )
}
</script>

<template>
  <component :is="$attrs.is ?? 'button'" @click="login(provider)">
    <slot>
      Logg inn med <span class="capitalize" v-text="provider" />
    </slot>
  </component>
</template>
